import { z } from '@betty/toolkit/api';

const LimitTypeSchema = z.enum(['Loss', 'Deposit', 'Time']);

export type LimitType = z.infer<typeof LimitTypeSchema>;

const PeriodTypeSchema = z.enum(['Daily', 'Weekly', 'Monthly']);
export type PeriodType = z.infer<typeof PeriodTypeSchema>;

export const LimitSchema = z.object({
  amount: z.number() || z.string(),
  accumulatedAmount: z.number() || z.string(),
  type: LimitTypeSchema,
  period: PeriodTypeSchema,
  resetDate: z.string().optional(),
  pendingAmount: z.number().optional(),
  activeFrom: z.string().optional(),
  setAt: z.string().optional(),
});

export type Limit = z.infer<typeof LimitSchema>;

export const LimitsResponseSchema = z.object({
  playerId: z.number(),
  limits: z.array(LimitSchema),
});
